import {
  Button,
  Modal,
  Form,
  Input,
  Flex,
  Typography,
  message,
  Select,
  Row,
  Col,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import { debounce } from "lodash";
const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [officeList, setOfficeList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [addRoleList, setAddRoleList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [ownerList, setOwnerList] = useState([]);
  const [trustList, setTrustList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [propList, setPropList] = useState([]);
 const [selectedAccount, setSelectedAccount] = useState(null);
  const [searchPropValue, setSearchPropValue] = useState("");
  const [managerIdList, setManagerIdList] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [isSelectVisible, setIsSelectVisible] = useState(false);
  const [selectedAccountView, setSelectedAccountView] = useState(null);
  const [accountViewData, setAccountViewData] = useState([]);
  const [error, setError] = useState(null);
  const [agentLoading, setAgentLoading] = useState(false);
   const [anetList, setAnetList] = useState([]);
  const StrengthLevel = {
    VERY_WEAK: 1,
    WEAK: 2,
    MEDIUM: 3,
    STRONG: 4,
    VERY_STRONG: 5,
  };

  const checkPasswordStrength = (password) => {
    if (!password) return StrengthLevel.VERY_WEAK;

    let score = 0;

    if (password.length >= 8) score++;
    if (password.length >= 12) score++;

    if (/[a-z]/.test(password)) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    if (/[~!@#$%^&*()_+`\-={}:;"'<>?,./\\[\]]/.test(password)) score++;

    if (score <= 1) return StrengthLevel.VERY_WEAK;
    if (score === 2) return StrengthLevel.WEAK;
    if (score === 3) return StrengthLevel.MEDIUM;
    if (score === 4) return StrengthLevel.STRONG;
    return StrengthLevel.VERY_STRONG;
  };
  const strengthMap = {
    1: { text: "Very Weak", color: "#ff4d4f" },
    2: { text: "Weak", color: "#ff7a45" },
    3: { text: "Medium", color: "#faad14" },
    4: { text: "Strong", color: "#52c41a" },
    5: { text: "Very Strong", color: "#237804" },
  };
  const [passwordStrength, setPasswordStrength] = useState(null);
  const isContractManagerList = [
    { value: 1, label: "Yes" },
    { value: 0, label: "No" },
  ];
    const   isInsuranceAgentList = [
    { value: 0, label: " " },
    { value: 1, label: "Yes" },
    { value: 2, label: "No" },
  ];
  useImperativeHandle(ref, () => ({
    setModelAdd: async () => {
      try {
        form.resetFields();
        setPasswordStrength(null); 
        setVisible(true);
        await Promise.all([
          getOfficeList(),
          getManagerIdList(),
          getCompanyList(),
          getOwner(),
          getTrust(),
          getGroup(),
          getProp(),
          getAddRloeList(),
          getSearchAccount(),
        ]);
      } catch (error) {
        message.error("Failed to initialize modal data");
        console.error("Initialization error:", error);
      }
    },
  }));
  const getOfficeList = async (search = "") => {
    try {
      const response = await http.get(api.getOfficeList, {
        params: { search },
      });

      if (response.code === "1") {
        const formattedOffices = response.data.map((office) => ({
          value: office,
          label: office,
        }));
        setOfficeList(formattedOffices);
      } else {
        message.error(response.msg || "Failed to fetch office list");
      }
    } catch (error) {
      message.error("Error fetching office list");
      throw error;
    } finally {
    }
  };

  const getManagerIdList = async () => {
    const response = await http.get(api.contractSearchAccount);
    if (response.code === "1") {
      const list = (response.data || []).map((item) => ({
        value: item.accountId,
        label: item.roleAllName,
      }));
      // console.log("list", list);
      setManagerIdList(list);
    }
  };

  const getOwner = async () => {
    try {
      const response = await http.get(api.getOwnerList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          value: item.ownerId,
          label: item.ownerCode,
        }));
        setOwnerList(formattedRole);
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };

  const getTrust = async () => {
    try {
      const response = await http.get(api.getTrustList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          value: item.trustId,
          label: item.trustName,
        }));
        setTrustList(formattedRole);
        return formattedRole;
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };
  const getGroup = async () => {
    try {
      const response = await http.get(api.getGroupList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          value: item.groupId,
          label: item.groupCode,
        }));
        setGroupList(formattedRole);
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };

  const getCompanyList = async () => {
    try {
      const response = await http.get(api.getCompanyList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          value: item.companyId,
          label: item.companyName,
        }));
        setCompanyList(formattedRole);
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };
  const getSearchAccount = async () => {
    try {
      const response = await http.get(`${api.contractSearchAccount}`);
      if (response?.data) {
        const formattedData = response.data
          .map((item) => ({
            //  value: item.accountId,
            value: String(item.accountId),
            label: item.allname || item.roleAllName,
          }))
          .filter((item) => item.value);
        setAccountData(formattedData);
        setAccountViewData(formattedData);
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };
  const getAddRloeList = async () => {
    try {
      const response = await http.get(api.getRolesList);

      if (response.code === "1") {
        const formattedRole = response.data.map((item) => ({
          value: item.roleId,
          label: item.roleName,
        }));
        setAddRoleList(formattedRole);
      }
    } catch (error) {
      message.error("Error fetching Company List");
      throw error;
    } finally {
    }
  };
  const getAgentTypeList = async () => {
    if (anetList.length > 0 || agentLoading) return;

    setAgentLoading(true);

    try {
      const res = await http.get(api.getAgentType);
      const data = res?.data || res;

      const list = (data || []).map((item) => ({
        value: item.vendorId,
        label: item.vendorName,
      }));

      setAnetList(list);
    } catch (err) {
      message.error("Request Error");
    } finally {
      setAgentLoading(false);
    }
  };
  const handleChangeUpdata = (value, e) => {
    setSelectedAccount(value);
  
  };
  const handleClear = () => {
    setSelectedAccount(null);
  };

  const getProp = async (content = "") => {
    const response = await http.get(api.propSearch, { params: { content } });
    if (response.code === "1") {
      const list = (response.data || []).map((item) => ({
        ...item,
        value: item.propId,
        label: item.propName,
      }));
      setPropList(list);
    }
  };

  const handleSearch = debounce((value) => {
    setSearchValue(value);
    getOfficeList(value);
  }, 500);

  const handleChangeView = (value) => {
    console.log("选中数据", value);
    form.setFieldsValue({ viewIds: value });
    setSelectedAccount(value);
  };
  const handleClearView = () => {
    setSelectedAccountView(null);
  };

  const onFinishAdd = async (values) => {
    try {
      setLoading(true);
      const queryParams = {
        password: values.password,
        confirmPassword: values.confirmPassword,
        firstname: values.firstname,
        middlename: values.middlename,
        lastname: values.lastname,
        phone: values.phone,
        office: values.office,
        cellphone: values.cellphone,
        ext: values.ext,
        email: values.email,
        location: values.location,
        note: values.note,
        accountRoleId: values.accountRoleId,
        roleIds: values.roleIds,
        groupIds: values.groupIds,
        propIds: values.propIds,
        companyIds: values.companyIds,
        ownerIds: values.ownerIds,
        trustIds: values.trustIds,
        showIds: values.showIds,
        viewIds: values.viewIds,
        isContractManager: values.isContractManager,
        managerIds: values.managerIds,
        enableApp: values.enableApp,
        isInsuranceAgent:values.isInsuranceAgent,
         agentIds: values.agentIds || []
      };
      // console.log(queryParams);
      const response = await http.post(`${api.getSaveAccount}`, queryParams);
      if (response.code === "1") {
        message.success("Add user successfully");
        setVisible(false);
        form.resetFields();
        // window.location.reload();
        onSuccess?.();
      } else {
        message.error(response.msg);
      }
    } catch (error) {
      // message.error(response.msg);
    } finally {
      setLoading(false);
    }
  };

  // 密码验证规则
  const passwordRules = [
    { required: true, message: "Please input your password!" },
    {
      validator(_, value) {
        const level = checkPasswordStrength(value);
        if (level >= StrengthLevel.MEDIUM) {
          return Promise.resolve();
        }
        return Promise.reject(new Error("Password strength is too weak."));
      },
    },
  ];

  // 确认密码验证
  const validateConfirmPassword = ({ getFieldValue }) => ({
    validator(_, value) {
      if (!value || getFieldValue("password") === value) {
        return Promise.resolve();
      }
      return Promise.reject(
        new Error("The passwords entered twice are inconsistent."),
      );
    },
  });
  const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            Add Account
          </Typography.Title>
        </Flex>
      }
      width="70%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields(); 
        setPasswordStrength(null); 
      }}
      footer={
         <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields(); 
            setPasswordStrength(null); 
          }}
        >
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <Form
            {...layout}
            // labelAlign={left}
            name="passwordResetForm"
            onFinish={onFinishAdd}
            form={form}
          >
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                    marginLeft: "20px",
                  }}
                >
                  User Contact Info
                </div>
                <Form.Item
                  name="firstname"
                  label="First Name"
                  rules={[
                    {
                      required: true,
                      message: "Please fill in first name",
                    },
                  ]}
                >
                  <Input placeholder="Please fill in first name." allowClear />
                </Form.Item>

                <Form.Item name="middlename" label="Middle Name">
                  <Input placeholder="Please fill in middle name." allowClear />
                </Form.Item>

                <Form.Item
                  name="lastname"
                  label="Last Name"
                  rules={[
                    {
                      required: true,
                      message: "Please fill in last name",
                    },
                  ]}
                >
                  <Input placeholder="Please fill in last name." allowClear />
                </Form.Item>

                <Form.Item
                  name="email"
                  label="Email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your email!",
                    },
                  ]}
                >
                  <Input placeholder="Enter email" allowClear />
                </Form.Item>
                <Form.Item
                  name="password"
                  label="New Password"
                  rules={passwordRules}
                >
                  <Input.Password
                    placeholder="Please enter a new password."
                    allowClear
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!value) {
                        setPasswordStrength(null);
                      } else {
                        setPasswordStrength(checkPasswordStrength(value));
                      }
                    }}
                  />
                </Form.Item>
                {passwordStrength && (
                  <div
                    style={{
                      marginTop: -12,
                      marginBottom: 16,
                      marginLeft: 300,
                    }}
                  >
                    <div
                      style={{
                        height: 6,
                        width: `${passwordStrength * 20}%`,
                        backgroundColor: strengthMap[passwordStrength].color,
                        borderRadius: 4,
                        transition: "all 0.3s",
                      }}
                    />
                    <div
                      style={{
                        marginTop: 4,
                        fontSize: 12,
                        color: strengthMap[passwordStrength].color,
                      }}
                    >
                      {strengthMap[passwordStrength].text}
                    </div>
                  </div>
                )}
                <Form.Item
                  name="confirmPassword"
                  label="Confirm Password"
                  rules={[
                    {
                      required: true,
                      message: "Please enter the password again.",
                    },
                    validateConfirmPassword,
                  ]}
                >
                  <Input.Password
                    placeholder="Please enter the password again."
                    allowClear
                  />
                </Form.Item>
                <Form.Item name="phone" label="Office Phone">
                  <Input
                    type="text"
                    placeholder="Please enter your cell phone number"
                    allowClear
                  />
                </Form.Item>

                <Form.Item name="ext" label="Extension">
                  <Input
                    placeholder="Please enter your extension."
                    allowClear
                  />
                </Form.Item>

                <Form.Item
                  name="cellphone"
                  label="Cell Phone"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your cell phone number",
                    },
                  ]}
                >
                  <Input
                    type="text"
                    placeholder="Please enter your cell phone number"
                    allowClear
                  />
                </Form.Item>

                <Form.Item name="location" label="Company Work Under">
                  <Input
                    placeholder="Please enter Company Work Under"
                    allowClear
                  />
                </Form.Item>

                <Form.Item name="office" label="Office Location">
                  <Select
                    placeholder="Select work office"
                    options={officeList}
                    onSearch={handleSearch}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item name="note" label="Note">
                  <Input placeholder="Please enter note" allowClear />
                </Form.Item>

                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                    marginLeft: "20px",
                  }}
                >
                  User Account Access
                </div>
                <Form.Item name="roleIds" label="Role">
                  <Select
                    placeholder="Select Role"
                    options={addRoleList}
                    mode="multiple"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item name="companyIds" label="Company">
                  <Select
                    placeholder="Select Company"
                    mode="multiple"
                    options={companyList}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item name="ownerIds" label="Owner">
                  <Select
                    placeholder="Select Owner"
                    options={ownerList}
                    mode="multiple"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
                <Form.Item name="trustIds" label="Trust">
                  <Select
                    placeholder="Select Trust"
                    options={trustList}
                    mode="multiple"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item name="groupIds" label="Group">
                  <Select
                    placeholder="Select Group"
                    options={groupList}
                    mode="multiple"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>

                <Form.Item name="propIds" label="Prop">
                  <Select
                    placeholder="Select Prop"
                    mode="multiple"
                    options={propList}
                    allowClear
                    showSearch
                    filterOption={false}
                    onSearch={(value) => {
                      setSearchPropValue(value);
                      getProp(value);
                    }}
                    notFoundContent={
                      setSearchPropValue ? "No results" : "Type to search"
                    }
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                    marginLeft: "20px",
                  }}
                >
                  Accounts Payable Access
                </div>

                <Form.Item
                  name="viewIds"
                  label="View Others' Approval Request & Process"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Select
                    mode="multiple"
                    showSearch
                    placeholder="Assign To"
                    optionFilterProp="children"
                    onChange={handleChangeView}
                    onClear={handleClearView}
                    allowClear
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    options={accountViewData}
                    loading={loading}
                    style={{ width: "100%" }}
                  />
                </Form.Item>
                <Form.Item
                  name="showIds"
                  label="Who Can View My Approval Request"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Select
                    mode="multiple"
                    showSearch
                    placeholder="Assign To"
                    optionFilterProp="children"
                    onChange={handleChangeUpdata}
                    onClear={handleClear}
                    allowClear
                    onBlur={() => setIsSelectVisible(false)}
                    filterOption={(input, option) =>
                      (option?.label ?? "")
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    value={selectedAccount || undefined}
                    options={accountData}
                    loading={loading}
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                    marginLeft: "20px",
                  }}
                >
                  Major Project
                </div>

                <Form.Item
                  name="isContractManager"
                  label="P.M"
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 18 }}
                >
                  <Select
                    placeholder="Select Group"
                    options={isContractManagerList}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <Form.Item
                  name="ids"
                  label="View Other Account"
                  labelCol={{ span: 6 }}
                  wrapperCol={{ span: 18 }}
                >
                  <Select
                    placeholder="Select Owner"
                    options={managerIdList}
                    mode="multiple"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>

                <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                    marginLeft: "20px",
                  }}
                >
                  App
                </div>

                <Form.Item
                  name="enableApp"
                  label="App Active"
                  labelCol={{ span: 4 }}
                  wrapperCol={{ span: 20 }}
                  rules={[
                    {
                      required: true,
                      message: "Please Select App Active",
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Group"
                    options={[
                      { value: 1, label: "Active" },
                      { value: 0, label: "Inactive" },
                    ]}
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%" }}
                  />
                </Form.Item>


                    <div
                  style={{
                    marginBottom: "16px",
                    fontWeight: "bold",
                    fontSize: "20px",
                    marginLeft: "20px",
                  }}
                >
                 Insurance
                </div>

           <Form.Item
    name="isInsuranceAgent"
    label="View All"
    labelCol={{ span: 6 }}
    wrapperCol={{ span: 18 }}
  >
    <Select
      placeholder="Select Insurance Agent"
      options={isInsuranceAgentList}
      allowClear
      style={{ width: "100%" }}
       onChange={(value) => {
      if (value !== 2) {
        form.setFieldsValue({ agentIds: [] });
      }
    }}
  />
  </Form.Item>


  <Form.Item shouldUpdate noStyle>
    {({ getFieldValue }) => {
      const type = getFieldValue("isInsuranceAgent");

      return (

    <Form.Item
        name="agentIds"
        label="View Agent"
          labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
         rules={
         type === 2
             ? [{ required: true, message: "Select Agent" }]
            : []
       }
      >
    <Select
    mode="multiple"
    placeholder="Select Owner"
    options={anetList}
    loading={agentLoading}
    allowClear
    showSearch
    optionFilterProp="label"
    disabled={type !== 2}
    onChange={(value) => {
   
      form.setFieldsValue({
        agentIds: Array.isArray(value) ? value : []
      });
    }}
    onDropdownVisibleChange={(open) => open && getAgentTypeList()}
  />
 </Form.Item>
      );
    }}
  </Form.Item>


              </Col>
            </Row>
          </Form>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;
